import { Notifier } from "@opendaw/lib-std";
// Open plugin webviews by device uuid: the engine's `wclapSend` lands in the registered receiver
export var WclapGuis;
(function (WclapGuis) {
    const guis = new Map();
    WclapGuis.register = (uuid, receiver) => {
        guis.set(uuid, receiver);
        return {
            terminate: () => {
                if (guis.get(uuid) !== receiver) {
                    return;
                }
                guis.delete(uuid);
                hovered.delete(uuid);
            }
        };
    };
    WclapGuis.deliver = (uuid, bytes) => guis.get(uuid)?.(bytes);
    // clap.param-hovered per device, -1 = none
    const hovered = new Map();
    const notifier = new Notifier();
    WclapGuis.hover = (uuid, paramId) => {
        hovered.set(uuid, paramId);
        notifier.notify({ uuid, paramId });
    };
    WclapGuis.hoveredParam = (uuid) => hovered.get(uuid) ?? -1;
    WclapGuis.subscribeHovered = (uuid, procedure) => notifier.subscribe(event => { if (event.uuid === uuid) {
        procedure(event.paramId);
    } });
    // clap.gui request_resize per device
    const resizes = new Notifier();
    WclapGuis.resize = (uuid, width, height) => resizes.notify({ uuid, size: { width, height } });
    WclapGuis.subscribeResize = (uuid, procedure) => resizes.subscribe(event => { if (event.uuid === uuid) {
        procedure(event.size);
    } });
})(WclapGuis || (WclapGuis = {}));
